/* cl-catalogue.js: the Black Friday catalogue (sections/cl-catalogue.liquid, ANZ 2026-10-14).
 *
 * - Filter chips ([data-clcat-filter]): all | 12 | 34 | outdoor | addon. Cards carry
 *   data-kind (indoor | outdoor | addon | tower) and data-size (12 | 34). A group with no
 *   visible card hides; the help card follows the indoor group. After a pick the page
 *   scrolls to the first visible group (under the sticky bar).
 * - Sort ([data-clcat-sort]): price low to high / high to low inside each grid, by the
 *   server-rendered data-price (cents, the same price the card prints). The help card stays
 *   last, the tower stays after the outdoor cards.
 * - Phone sticky bar ([data-clcat-sticky]): shown once the hero has scrolled away, hidden
 *   while the final band ([data-lpbf-hide-sticky]) is on screen.
 * - Cart count in the sticky bar follows cl-commerce.js's cl:cart-added / cl:cart-updated.
 * Add to cart itself is cl-commerce.js ([data-cl-quick-add]): /cart/add.js, cart drawer.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-clcat]');
  if (!root || root.dataset.clcatReady) return;
  root.dataset.clcatReady = '1';

  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-clcat-group]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-clcat-filter]'));
  var bar = root.querySelector('[data-clcat-bar]');

  function matches(card, f) {
    var k = card.getAttribute('data-kind');
    var s = card.getAttribute('data-size');
    if (f === 'all') return true;
    if (f === '12' || f === '34') return (k === 'indoor' || k === 'outdoor') && s === f;
    if (f === 'outdoor') return k === 'outdoor';
    if (f === 'addon') return k === 'addon' || k === 'tower';
    return true;
  }

  function apply(f, scroll) {
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-clcat-filter') === f ? 'true' : 'false'); });
    var first = null;
    groups.forEach(function (g) {
      var any = false;
      g.querySelectorAll('[data-clcat-card]').forEach(function (card) {
        var on = matches(card, f);
        var cell = card.closest('.clcat-cell') || card;
        cell.hidden = !on;
        if (on) any = true;
      });
      var help = g.querySelectorAll('.clcat-cell.is-help, .clcat-help-phone');
      help.forEach(function (h) { h.hidden = !(f === 'all' || f === '12' || f === '34'); });
      g.hidden = !any;
      if (any && !first) first = g;
    });
    if (scroll && first) {
      var top = first.getBoundingClientRect().top + window.pageYOffset;
      var off = (bar ? bar.offsetHeight : 0) + (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cl-nav-h')) || 0);
      window.scrollTo({ top: Math.max(0, top - off + 1), behavior: 'smooth' });
    }
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () { apply(c.getAttribute('data-clcat-filter'), true); });
  });

  var sort = root.querySelector('[data-clcat-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var dir = sort.value === 'desc' ? -1 : 1;
      root.querySelectorAll('[data-clcat-grid]').forEach(function (grid) {
        var cells = Array.prototype.slice.call(grid.children);
        var cards = cells.filter(function (c) { var k = c.querySelector('[data-clcat-card]') || (c.hasAttribute('data-clcat-card') ? c : null); return k && c.classList.contains('clcat-cell') && !c.classList.contains('is-tower'); });
        var rest = cells.filter(function (c) { return cards.indexOf(c) === -1; });
        cards.sort(function (a, b) {
          var pa = Number((a.querySelector('[data-clcat-card]') || a).getAttribute('data-price')) || 0;
          var pb = Number((b.querySelector('[data-clcat-card]') || b).getAttribute('data-price')) || 0;
          return (pa - pb) * dir;
        });
        cards.concat(rest).forEach(function (c) { grid.appendChild(c); });
      });
    });
  }

  /* cart count in the sticky bar */
  var count = root.querySelector('[data-clcat-count]');
  function refresh() {
    if (!count) return;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') count.textContent = c.item_count; })
      .catch(function () {});
  }
  document.addEventListener('cl:cart-added', function () { setTimeout(refresh, 300); });
  document.addEventListener('cl:cart-updated', function (e) {
    var d = e.detail;
    if (d && typeof d.item_count === 'number' && count) count.textContent = d.item_count; else refresh();
  });

  /* phone sticky bar */
  var sticky = root.querySelector('[data-clcat-sticky]');
  var hero = root.querySelector('.clcat-hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var pastHero = false;
    var blockers = new Set();
    function update() { sticky.classList.toggle('is-shown', pastHero && blockers.size === 0); }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; });
      update();
    }).observe(hero);
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) blockers.add(e.target); else blockers.delete(e.target); });
      update();
    });
    document.querySelectorAll('[data-lpbf-hide-sticky]').forEach(function (el) { io.observe(el); });
  }
})();
